
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skianlegg",
      function () {
        return require("private-next-pages/skianlegg.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skianlegg"])
      });
    }
  